export function Logo() {
  return (
    <div className="mx-2 sm:mx-4">
      <img
        src="/assets/logo/rr-logo--navbar--bg-transparent.png"
        width={32}
        height={32}
        alt="Logo"
      />
    </div>
  );
}
